import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/thumbs-down",
  "use": "app/thumbs-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/thumbs-down\"><path d=\"M2.6 3.08L.132 11.21a2.944 2.944 0 002.814 3.802h5.707v4.238c0 3.334 2.84 2.88 2.84 2.88l5.121-9.152V1H5.428a2.944 2.944 0 00-2.827 2.08zM21.019 1h-2.652v11.517h2.652a.982.982 0 00.981-.982V1.981A.982.982 0 0021.019 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol